import React, { Component } from 'react';
import { Table, Glyphicon, Button } from 'react-bootstrap';
import Panels from './panels';
import i18n from 'kodyl-js/i18n/react';
import { connect } from 'react-redux';
import {
  deleteBoligagent,
  deletePref,
  updateBoligagent,
  UPDATE_FAIL,
  DELETE_PREF_FAIL,
  activatePref,
  ACTIVATE_FAIL,
  setAutoAdjust
} from '../../redux/modules/boligagents';
import ErrorMessage from '../../common/error-message';

function selectPanel(area, val) {
  if (!val) {
    return area;
  }
  return area === val ? false : area;
}

@connect(
  ({ boligagents: { current, loading }, cities: { list } }) => ({
    current,
    loading,
    list
  }),
  {
    deleteBoligagent,
    deletePref,
    updateBoligagent,
    activatePref,
    setAutoAdjust
  }
)
@i18n
class Boligagents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
      open: false,
      pref: {}
    };
  }

  unsubscribe = event => {
    event.preventDefault();
    const { deleteBoligagent } = this.props;
    this.setState({ open: false });
    deleteBoligagent();
  };
  deletePref = area => {
    const {
      deletePref,
      current: { id }
    } = this.props;
    deletePref({ id, area }).then(action => {
      this.setState({ error: action.type === DELETE_PREF_FAIL ? true : false });
      return action;
    });
  };

  activatePref = (id, area) => {
    const { activatePref } = this.props;
    activatePref({ id, area }).then(action => {
      this.setState({ error: action.type === ACTIVATE_FAIL ? true : false });
      return action;
    });
  };

  togglePanel = (area, agent) => {
    this.setState({
      open: selectPanel(area, this.state.open),
      pref: {
        area,
        rent: agent.rent,
        rooms: agent.rooms,
        size: agent.size
      }
    });
  };

  update = (area, prefs) => {
    const {
      current: { id },
      updateBoligagent
    } = this.props;
    this.setState({ open: false });
    updateBoligagent({ id, area, prefs: { ...prefs } }).then(action => {
      this.setState({ error: action.type === UPDATE_FAIL ? true : false });
      return action;
    });
  };

  prepArea = area => {
    const { list } = this.props;
    const preppedArea = list.filter(city => city.slug === area);
    return preppedArea.length > 0 ? preppedArea[0].label : area;
  };

  toggleAutoAdjust = ev => {
    ev.preventDefault();
    this.props.setAutoAdjust({ autoAdjust: ev.target.checked });
  };

  render() {
    const { current, loading } = this.props;
    const prefs = (current && current.prefs) || [];
    const { error, open, pref } = this.state;

    if (!current && !loading) {
      return (
        <div>
          {this.i18n(
            'Your BoligAgents is inactive, and you do not receive any new offers for available dwellings.'
          )}
        </div>
      );
    }

    return (
      <div id="profile-boligagents">
        {error ? (
          <ErrorMessage
            text={this.i18n(
              'An error occurred. Please try again or contact customer support.'
            )}
          />
        ) : null}
        <p>
          {this.i18n(
            'Med en boligagent får du gratis besked, så snart der er et ledigt lejemål, der lever op til dine krav. Du kan slette eller rette i dine boligagenter her:'
          )}
        </p>
        {prefs.length ? (
          <Table responsive condensed className="boligagent">
            <thead>
              <tr>
                <th>{this.i18n('Area')}</th>
                <th>{this.i18n('Rent')}</th>
                <th>{this.i18n('Rooms')}</th>
                <th>{this.i18n('Size')}</th>
              </tr>
            </thead>
            {prefs.map((agent, idx) => (
              <tbody key={idx}>
                <tr className={agent.status ? '' : 'panel-blur'}>
                  <td>{this.prepArea(agent.area)}</td>
                  <td>
                    {agent.rent
                      ? `${agent.rent} ${this.i18n('DKK')}`
                      : this.i18n('Ingen krav')}
                  </td>
                  <td>{agent.rooms || this.i18n('Ingen krav')}</td>
                  <td>
                    {agent.size
                      ? `${agent.size} ${this.i18n('m2')}`
                      : this.i18n('Ingen krav')}
                  </td>
                  {agent.status ? (
                    <td className="panel-border" style={{ textAlign: 'right' }}>
                      <Button
                        onClick={() => this.deletePref(agent.area)}
                        bsStyle="danger"
                        bsSize="small"
                      >
                        <Glyphicon glyph="trash" />
                      </Button>
                      &nbsp;
                      <Button
                        onClick={() =>
                          this.togglePanel(agent.area, {
                            rent: agent.rent,
                            rooms: agent.rooms,
                            size: agent.size
                          })
                        }
                        bsStyle="primary"
                        bsSize="small"
                      >
                        <Glyphicon glyph="pencil" />
                      </Button>
                    </td>
                  ) : null}
                  {!agent.status ? (
                    <td
                      className="panel-border"
                      style={{ textAlign: 'right' }}
                      onClick={() => this.activatePref(current.id, agent.area)}
                    >
                      <Button bsStyle="success" bsSize="small">
                        {this.i18n('Activate')}
                      </Button>
                    </td>
                  ) : null}
                </tr>
                <tr>
                  <td colSpan="5" style={{ padding: 0, border: 0 }}>
                    <Panels
                      open={open === agent.area}
                      update={this.update}
                      area={pref.area}
                      prefs={{
                        rent: pref.rent,
                        rooms: pref.rooms,
                        size: pref.size
                      }}
                    />
                  </td>
                </tr>
              </tbody>
            ))}
          </Table>
        ) : (
          <div>
            {loading
              ? this.i18n('Siden indlæses. Et øjeblik')
              : this.i18n('Du har ikke valgt nogen BoligAgenter.')}
          </div>
        )}
        <hr />
        <input
          className="adjustment"
          type="checkbox"
          checked={current.autoAdjust}
          onChange={this.toggleAutoAdjust}
        />
        &nbsp;&nbsp;Dine boligagenter bliver løbende justeret, så de altid er
        tilpasset dine ønsker.{' '}
        {current.autoAdjust
          ? this.i18n('Afmeld her')
          : this.i18n('Tilmeld her')}
        <hr />
        <h4>{this.i18n('Delete %s', this.i18n('BoligAgents'))}</h4>
        {this.i18n(
          'Ønsker du at slette alle dine gratis boligagenter på én gang, så du ikke længere modtager e-mails om ledige lejemål, kan du klikke her.'
        )}
        <br />
        <a onClick={this.unsubscribe}>
          {this.i18n('Yes, please delete all my %s', this.i18n('BoligAgents'))}
        </a>
        <br />
        <br />
      </div>
    );
  }
}

export default Boligagents;
